module.exports = __webpack_public_path__ + "img/924ba7f.jpg";